import React, { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import "./AgentEmployeeStatusMenu.scss";

export type EmployeeConfirmType =
  | "activate"
  | "deactivate"
  | "archive"
  | "unarchive";

const AgentEmployeeStatusMenu = ({
  status,
  onRequestAction,
}: {
  status: string;
  onRequestAction: (type: EmployeeConfirmType) => void;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorEl);
  const normalized = (status || "").toLowerCase();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const activateLabel = normalized === "active" ? "Deactivate" : "Activate";
  const activateType: EmployeeConfirmType =
    normalized === "active" ? "deactivate" : "activate";

  const archiveLabel = normalized === "archived" ? "Unarchive" : "Archive";
  const archiveType: EmployeeConfirmType =
    normalized === "archived" ? "unarchive" : "archive";

  const handleSelect = (type: EmployeeConfirmType) => {
    handleClose();
    onRequestAction(type);
  };

  return (
    <>
      <div
        className="property-menu-icon"
        onClick={handleClick}
        id="employee-action-btn"
        aria-controls={open ? "employee-action-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <MoreVertIcon fontSize="small" />
      </div>

      <Menu
        id="employee-action-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ "aria-labelledby": "employee-action-btn" }}
        className="users-list-menu-icon-menu"
        autoFocus={false}
        PaperProps={{
          elevation: 3,
          sx: { mt: 1, borderRadius: 2, minWidth: 160 },
        }}
      >
        <MenuItem onClick={() => handleSelect(activateType)}>
          {activateLabel}
        </MenuItem>
        <MenuItem onClick={() => handleSelect(archiveType)}>
          {archiveLabel}
        </MenuItem>
      </Menu>
    </>
  );
};

export default AgentEmployeeStatusMenu;
